import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  openModal: `${NAMESPACE}_MODALS_OPEN`,
  closeModal: `${NAMESPACE}_MODALS_CLOSE`
};

export const actionCreators = {
  openModal: payload => ({ type: actions.openModal, payload }),
  closeModal: payload => ({ type: actions.closeModal, payload })
};

export default {
  actions,
  actionCreators,
};
